import { WidgetModel } from './widget.model';
import { isDefined } from '@fi-shared/utils/is-defined';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';

export class NewsFeedWidgetModel extends WidgetModel {
    onControlInitialized(control: WidgetPlaceHolderControlModel) {
        super.onControlInitialized(control);
        if (!isDefined(control.Settings.ShowForumActivity)) {
            control.Settings.ShowForumActivity = true;
        }
    }
}
